import { GET_LIST_INVOICE_BY_CUSTOMER } from './invoiceTypes'
import { Invoice } from "../../models/invoice/invoice"

export default {
  [GET_LIST_INVOICE_BY_CUSTOMER](state, data) {
    state.invoiceByCustomerData = data;
    let invoice_arr = [];
    for(let i = 0; i < data.items.length; i++) {
      invoice_arr.push(new Invoice(data.items[i]));
    }
    state.invoiceByCustomerList = invoice_arr;
  },
}
